import { useEffect, useState } from "react";

const ConfirmModal = ({
  isOpen,
  onClose,
  onSubmit,
  message,
  isForm = false,
  title = "Xác nhận",
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
      setFormData({ name: "", email: "", phone: "" });
      setErrors({});
      setIsSubmitting(false);
    }
  }, [isOpen]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Họ và tên không được để trống.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email không được để trống.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Email không hợp lệ.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Số điện thoại không được để trống.";
    } else if (!/^(\+84|0)[0-9]{9}$/.test(formData.phone)) {
      newErrors.phone = "Số điện thoại không hợp lệ.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async () => {
    if (isForm) {
      if (!validate()) return;
    }

    setIsSubmitting(true);
    await new Promise((r) => setTimeout(r, 0));
    try {
      if (isForm) {
        await onSubmit(formData);
      } else {
        await onSubmit();
      }
    } catch (error) {
      console.error("Submit failed:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-base-100 rounded-lg p-6 w-100 shadow-lg">
        <h2 className="text-lg font-semibold text-center">{title}</h2>
        <p className="mt-2 text-center whitespace-pre-line">{message}</p>

        {isForm && (
          <div className="mt-4 space-y-3">
            <div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Họ và tên"
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>

            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">{errors.email}</p>
              )}
            </div>

            <div>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Số điện thoại"
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              />
              {errors.phone && (
                <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
              )}
            </div>
          </div>
        )}

        <div className="mt-4 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-base rounded transition btn btn-ghost"
            disabled={isSubmitting}
          >
            Đóng
          </button>
          {onSubmit && (
            <button
              onClick={handleSubmit}
              className="px-4 py-2 text-base  rounded  transition btn btn-success"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Vui lòng đợi ..." : "Đồng ý"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
